module.exports = __webpack_public_path__ + "e64ca5bdd3652bda8960d3a05826af93.pdf";